module.exports = __webpack_public_path__ + "static/3-dc5d10045f63905c84aaf582af6f64f5.png";